import { render } from "./ResumenTrade.vue?vue&type=template&id=15579ec2"
import script from "./ResumenTrade.vue?vue&type=script&lang=js"
export * from "./ResumenTrade.vue?vue&type=script&lang=js"

import "./ResumenTrade.vue?vue&type=style&index=0&id=15579ec2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__